import { render, staticRenderFns } from "./PatientDetailSection.vue?vue&type=template&id=d1e6af28&"
import script from "./PatientDetailSection.vue?vue&type=script&lang=js&"
export * from "./PatientDetailSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports